import React, { useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    scrollY
  } = useScroll();
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-white/98 backdrop-blur-md shadow-[0_1px_20px_rgba(0,0,0,0.08)] py-2' : 'bg-transparent py-3 md:py-5'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-57">
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center" data-id="element-58">
        {/* Brand — compact on mobile */}
        <div className={`shrink-0 ${isScrolled ? 'text-[#111111]' : 'text-white'}`} data-id="element-59">
          <span className="font-black text-[15px] md:text-2xl tracking-tight uppercase" data-id="element-60">
            MITCHELL
          </span>
          <span className="text-[#d4a853] font-light text-[10px] md:text-lg tracking-wide uppercase ml-1 hidden sm:inline" data-id="element-61">
            The Kia Boss
          </span>
        </div>

        {/* Right side — language + CTA */}
        <div className="flex items-center gap-1.5 md:gap-3" data-id="element-62">
          <div className={`flex rounded-full overflow-hidden ${isScrolled ? 'bg-[#f4f4f4]' : 'bg-white/10 backdrop-blur-sm'}`} data-id="element-63">
            <button onClick={() => setLang('en')} className={`px-1.5 md:px-2 py-0.5 md:py-1 text-[9px] md:text-xs font-bold uppercase tracking-wider transition-all duration-300 ${lang === 'en' ? 'bg-[#C41230] text-white' : isScrolled ? 'text-[#6b6b6b] hover:text-[#111111]' : 'text-white/60 hover:text-white'}`} data-id="element-64">
              EN
            </button>
            <button onClick={() => setLang('es')} className={`px-1.5 md:px-2 py-0.5 md:py-1 text-[9px] md:text-xs font-bold uppercase tracking-wider transition-all duration-300 ${lang === 'es' ? 'bg-[#C41230] text-white' : isScrolled ? 'text-[#6b6b6b] hover:text-[#111111]' : 'text-white/60 hover:text-white'}`} data-id="element-65">
              ES
            </button>
          </div>

          <button onClick={scrollToForm} data-track-cta="header-cta" className="btn-primary py-1.5 md:py-2 px-3 md:px-6 rounded-md text-[10px] md:text-sm whitespace-nowrap" data-id="element-66">
            {t('header.cta')}
          </button>
        </div>
      </div>
    </motion.header>;
}